<div>
    <section #stepone class="section__steps" id="steps">
        <h1 class="header__title">Create your Request</h1>
        <div class="whenImage">
          <img src="../../../../assets/img/illustration_travelling-woman.svg" alt="Image with woman holding a suitcase">
        </div>
        <div class="required-steps-wrap">
          <div id="where" class="steps">
            <h2 class="stepWhereHeader">Where to?</h2>
            <div>
              <select class="button button--input" [value]="selectedLocation" name="whereSelect"
                [(ngModel)]="selectedLocation">
                <option *ngFor="let location of locations" [value]="location.value">{{ location.value }}
                </option>
              </select>
            </div>
          </div>
          <div id="when" class="steps">
            <div class="step1When">
              <h2 class="step1Header">When are you travelling?</h2>
              <div class="form-group">
                <div class="inputHolderMobile" (click)="datepickertoggle(); angulartics2Track('DatePickerToggled')">
                  <div class="form-group">
                    <div class="input-group">
                      <input #myRangeInput value="{{ checkInString }} -> {{ checkOutString }}" name="datepicker"
                        class="button button--input" ngbDatepicker container="body" #datepicker="ngbDatepicker"
                        [autoClose]="'outside'" (dateSelect)="onDateSelection($event)" [displayMonths]="2" [dayTemplate]="t"
                        [minDate]="minDate" outsideDays="hidden" [readonly]="true">
                      <ng-template #t let-date let-focused="focused">
                        <span class="custom-day" [class.disabled]="isDateDisabled(date)" [class.focused]="focused"
                          [class.range]="isRange(date)" [class.faded]="isHovered(date) || isInside(date)"
                          (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
                          {{ date.day }}
                        </span>
                      </ng-template>
                      <p *ngIf="noDatesSelected" class="noDatesSelected">Please select your travel dates</p>
                    </div>
                  </div>
                </div>
                <div class="nightCounter">
                  <span>{{ nights }}</span>
                  <span>nights</span>
                </div>
              </div>
            </div>
          </div>
          <div id="who" class="steps">
            <div class="step2">
              <div class="step2Who">
                <h2 class="step2Header">Who's going?</h2>
                <div class="mobileWhoContainer">
                  <div (click)="openRoomsModal(); angulartics2Track('RoomsModalToggled')" class="inputHolder">
                    <div class="button button--input">
                      <p>Rooms</p>
                      <p class="circleSelection roomPMobile">{{ roomModalRooms }}</p>
                    </div>
                    <div class="button button--input">
                      <p>Adults</p>
                      <p class="circleSelection">{{ roomModalAdults }}</p>
                    </div>
                    <div class="button button--input">
                      <p>Children</p>
                      <p class="circleSelection">{{ roomModalChildren }}</p>
                    </div>
                  </div>
                </div>
                <div [ngClass]="{'whoModalMobile': true, 'show': toShowRoomOptions}">
                  <div class="select__container">
                    <select class="button button--input" [value]="whoSelection" (change)="roomSelected()" name="roomsSelect"
                      id="room" [(ngModel)]="whoSelection">
                      <option *ngFor="let roomOpt of allRoomOptions" [value]="roomOpt.number">
                        {{ roomOpt.number }} Rooms</option>
                    </select>
                    <div class="button__container">
                      <button (click)="submitRoomsModal(); closeRoomModal()" class="button--confirm">Confirm</button>
                    </div>
                  </div>
                  <div class="whoModalDynamic">
                    <div class="roomOptContainer">
                      <div class="roomNumberOpt">
                        <p class="allowWhiteSpace">Room 1 </p>
                      </div>
                      <div class="select__container--small">
                        <div class="roomAdultsInput">
                          <p class="allowWhiteSpace">Adults: </p>
                        </div>
                        <div class="who-input-small">
                          <select [value]="adultsSelection" (change)="submitRoomsModal()"
                            name="adultsSelect" id="adult" class="room-control" [(ngModel)]="adultsSelection">
                            <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                              {{ roomOpt.number }}</option>
                          </select>
                        </div>
                        <div style="display:inline-block;" class="roomChildrenOpt">
                          <p class="allowWhiteSpace">Children: </p>
                        </div>
                        <select [value]="childrenSelection" (change)="submitRoomsModal()"
                          name="childrenSelect" id="child" class="room-control" [(ngModel)]="childrenSelection">
                          <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                            {{ roomOpt.number }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="roomOptContainer hiddenRoom" id="roomOptContainer2">
                      <div class="roomNumberOpt">
                        <p class="allowWhiteSpace">Room 2 </p>
                      </div>
                      <div class="select__container--small">
                        <div class="roomAdultsInput">
                          <p class="allowWhiteSpace">Adults: </p>
                        </div>
                        <select [value]="adultsSelection2" (change)="submitRoomsModal()"
                          name="adultsSelect" id="adult" class="room-control" [(ngModel)]="adultsSelection2">
                          <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                            {{ roomOpt.number }}</option>
                        </select>
                        <div style="display:inline-block;" class="roomChildrenOpt">
                          <p class="allowWhiteSpace">Children: </p>
                        </div>
                        <select [value]="childrenSelection2"
                          (change)="submitRoomsModal()" name="childrenSelect" id="child"
                          class="room-control" [(ngModel)]="childrenSelection2">
                          <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                            {{ roomOpt.number }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="roomOptContainer hiddenRoom" id="roomOptContainer3">
                      <div class="roomNumberOpt">
                        <p class="allowWhiteSpace">Room 3 </p>
                      </div>
                      <div class="select__container--small">
                        <div class="roomAdultsInput">
                          <p class="allowWhiteSpace">Adults: </p>
                        </div>
                        <select [value]="adultsSelection3" (change)="submitRoomsModal()"
                          name="adultsSelect" id="adult" class="room-control" [(ngModel)]="adultsSelection3">
                          <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                            {{ roomOpt.number }}</option>
                        </select>
                        <div style="display:inline-block;" class="roomChildrenOpt">
                          <p class="allowWhiteSpace">Children: </p>
                        </div>
                        <select [value]="childrenSelection3"
                          (change)="submitRoomsModal()" name="childrenSelect" id="child"
                          class="room-control" [(ngModel)]="childrenSelection3">
                          <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                            {{ roomOpt.number }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="roomOptContainer hiddenRoom" id="roomOptContainer4">
                      <div class="roomNumberOpt">
                        <p class="allowWhiteSpace">Room 4 </p>
                      </div>
                      <div class="select__container--small">
                        <div class="roomAdultsInput">
                          <p class="allowWhiteSpace">Adults: </p>
                        </div>
                        <select [value]="adultsSelection4" (change)="submitRoomsModal()"
                          name="adultsSelect" id="adult" class="room-control" [(ngModel)]="adultsSelection4">
                          <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                            {{ roomOpt.number }}</option>
                        </select>
                        <div style="display:inline-block;" class="roomChildrenOpt">
                          <p class="allowWhiteSpace">Children: </p>
                        </div>
                        <select [value]="childrenSelection4"
                          (change)="submitRoomsModal()" name="childrenSelect" id="child"
                          class="room-control" [(ngModel)]="childrenSelection4">
                          <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                            {{ roomOpt.number }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="roomOptContainer hiddenRoom" id="roomOptContainer5">
                      <div class="roomNumberOpt">
                        <p class="allowWhiteSpace">Room 5 </p>
                      </div>
                      <div class="select__container--small">
                        <div class="roomAdultsInput">
                          <p class="allowWhiteSpace">Adults: </p>
                        </div>
                        <select [value]="adultsSelection5" (change)="submitRoomsModal()"
                          name="adultsSelect" id="adult" class="room-control" [(ngModel)]="adultsSelection5">
                          <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                            {{ roomOpt.number }}</option>
                        </select>
                        <div style="display:inline-block;" class="roomChildrenOpt">
                          <p class="allowWhiteSpace">Children: </p>
                        </div>
                        <select [value]="childrenSelection5"
                          (change)="submitRoomsModal()" name="childrenSelect" id="child"
                          class="room-control" [(ngModel)]="childrenSelection5">
                          <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                            {{ roomOpt.number }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="roomOptContainer hiddenRoom" id="roomOptContainer6">
                      <div class="roomNumberOpt">
                        <p class="allowWhiteSpace">Room 6 </p>
                      </div>
                      <div class="select__container--small">
                        <div class="roomAdultsInput">
                          <p class="allowWhiteSpace">Adults: </p>
                        </div>
                        <select [value]="adultsSelection6" (change)="submitRoomsModal()"
                          name="adultsSelect" id="adult" class="room-control" [(ngModel)]="adultsSelection6">
                          <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                            {{ roomOpt.number }}</option>
                        </select>
                        <div style="display:inline-block;" class="roomChildrenOpt">
                          <p class="allowWhiteSpace">Children: </p>
                        </div>
                        <select [value]="childrenSelection6"
                          (change)="submitRoomsModal()" name="childrenSelect" id="child"
                          class="room-control" [(ngModel)]="childrenSelection6">
                          <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                            {{ roomOpt.number }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="roomOptContainer hiddenRoom" id="roomOptContainer7">
                      <div class="roomNumberOpt">
                        <p class="allowWhiteSpace">Room 7 </p>
                      </div>
                      <div class="select__container--small">
                        <div class="roomAdultsInput">
                          <p class="allowWhiteSpace">Adults: </p>
                        </div>
                        <select [value]="adultsSelection7" (change)="submitRoomsModal()"
                          name="adultsSelect" id="adult" class="room-control" [(ngModel)]="adultsSelection7">
                          <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                            {{ roomOpt.number }}</option>
                        </select>
                        <div style="display:inline-block;" class="roomChildrenOpt">
                          <p class="allowWhiteSpace">Children: </p>
                        </div>
                        <select [value]="childrenSelection7"
                          (change)="submitRoomsModal()" name="childrenSelect" id="child"
                          class="room-control" [(ngModel)]="childrenSelection7">
                          <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                            {{ roomOpt.number }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="roomOptContainer hiddenRoom" id="roomOptContainer8">
                      <div class="roomNumberOpt">
                        <p class="allowWhiteSpace">Room 8 </p>
                      </div>
                      <div class="select__container--small">
                        <div class="roomAdultsInput">
                          <p class="allowWhiteSpace">Adults: </p>
                        </div>
                        <select [value]="adultsSelection8" (change)="submitRoomsModal()"
                          name="adultsSelect" id="adult" class="room-control" [(ngModel)]="adultsSelection8">
                          <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                            {{ roomOpt.number }}</option>
                        </select>
                        <div style="display:inline-block;" class="roomChildrenOpt">
                          <p class="allowWhiteSpace">Children: </p>
                        </div>
                        <select [value]="childrenSelection8"
                          (change)="submitRoomsModal()" name="childrenSelect" id="child"
                          class="room-control" [(ngModel)]="childrenSelection8">
                          <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                            {{ roomOpt.number }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="roomOptContainer hiddenRoom" id="roomOptContainer9">
                      <div class="roomNumberOpt">
                        <p class="allowWhiteSpace">Room 9 </p>
                      </div>
                      <div class="select__container--small">
                        <div class="roomAdultsInput">
                          <p class="allowWhiteSpace">Adults: </p>
                        </div>
                        <select [value]="adultsSelection9" (change)="submitRoomsModal()"
                          name="adultsSelect" id="adult" class="room-control" [(ngModel)]="adultsSelection9">
                          <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                            {{ roomOpt.number }}</option>
                        </select>
                        <div style="display:inline-block;" class="roomChildrenOpt">
                          <p class="allowWhiteSpace">Children: </p>
                        </div>
                        <select [value]="childrenSelection9"
                          (change)="submitRoomsModal()" name="childrenSelect" id="child"
                          class="room-control" [(ngModel)]="childrenSelection9">
                          <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                            {{ roomOpt.number }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="roomOptContainer hiddenRoom" id="roomOptContainer10">
                      <div class="roomNumberOpt">
                        <p class="allowWhiteSpace">Room 10 </p>
                      </div>
                      <div class="select__container--small">
                        <div class="roomAdultsInput">
                          <p class="allowWhiteSpace">Adults: </p>
                        </div>
                        <select [value]="adultsSelection10" (change)="submitRoomsModal()"
                          name="adultsSelect" id="adult" class="room-control" [(ngModel)]="adultsSelection10">
                          <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                            {{ roomOpt.number }}</option>
                        </select>
                        <div style="display:inline-block;" class="roomChildrenOpt">
                          <p class="allowWhiteSpace">Children: </p>
                        </div>
                        <select [value]="childrenSelection10"
                          (change)="submitRoomsModal()" name="childrenSelect" id="child"
                          class="room-control" [(ngModel)]="childrenSelection10">
                          <option *ngFor="let roomOpt of allRoomOptionsModal" [value]="roomOpt.number">
                            {{ roomOpt.number }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="exp-wish-wrap">
          <div id="exp" class="steps">
            <img src="../../../../assets/img/illustration_choose-exp.svg"
              alt="Hotelier showing the customer her options for added experiences" class="exp-img">
            <div class="experiences-wrap">
              <h2>What are you looking for?</h2>
              <h3>Choose up to 3
                <div class="subheading-icon-wrap">
                  <svg class="subheading-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 218 218">
                    <g id="Layer_2" data-name="Layer 2">
                      <g id="Layer_1-2" data-name="Layer 1">
                        <circle cx="109" cy="109" r="109" />
                        <path class="subheading-icon-i"
                          d="M83.62,90.37h41.32V167.6h9.44v3H84.3v-3h9.27V93.4H83.62Zm25.47-11.64q-9,0-12.74-4.55a17,17,0,0,1-3.79-11.3,15.62,15.62,0,0,1,4.13-11.13q4.14-4.38,12.56-4.38t12.82,4q4.38,4,4.38,11.3t-4.21,11.72Q118,78.73,109.09,78.73Z" />
                      </g>
                    </g>
                  </svg>
                </div>
                <div class="isTooltip">
                  <img src="../../../../assets/img/1000handpicked-01.svg"
                    alt="90 percent of our users that include a personal message receive discounts from our hoteliers">
                  <p>Share with our hosts your top three reasons you are travelling to Crete so they can
                    personalize your experience.</p>
                </div>
              </h3>
              <p *ngIf="currentSelectedExp === 3" id="maxExperiences">You have reached max chosen experiences!</p>
              <div class="expPreview">
                <button *ngFor="let exp of experiencesMappingRest let i = index"
                  (click)="addExpToList(exp.id, exp.checked, exp.position); angulartics2Track('ExperienceAdded')"
                  class="expChoice" id="{{ exp.id }}" mat-raised-button>
                  <!--<img class="exp__img"
                                  src="../../../../assets/img/icons/local-gastronomy_white-pink.svg" alt="">--><span
                    class="exp__title">{{ exp.name }}</span><br>
                  <!--<span class="exp__desc">Enjoy countless local delights from top chefs in the traditional Cretan
                                  cuisine.</span>-->
                </button>
              </div>
            </div>
          </div>
          <div id="wish" class="steps">
            <div class="wishImage">
              <img src="../../../../assets/img/illustration_wine-tasting.svg" alt="Illustration of a woman mountain climbing">
            </div>
            <h2>Any wish of yours?</h2>
            <h3>Make it personal
              <div class="subheading-icon-wrap">
                <svg class="subheading-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 218 218">
                  <g id="Layer_2" data-name="Layer 2">
                    <g id="Layer_1-2" data-name="Layer 1">
                      <circle cx="109" cy="109" r="109" />
                      <path class="subheading-icon-i"
                        d="M83.62,90.37h41.32V167.6h9.44v3H84.3v-3h9.27V93.4H83.62Zm25.47-11.64q-9,0-12.74-4.55a17,17,0,0,1-3.79-11.3,15.62,15.62,0,0,1,4.13-11.13q4.14-4.38,12.56-4.38t12.82,4q4.38,4,4.38,11.3t-4.21,11.72Q118,78.73,109.09,78.73Z" />
                    </g>
                  </g>
                </svg>
              </div>
              <div class="isTooltip">
                <img src="../../../../assets/img/90-percent-users_v4.svg"
                  alt="90 percent of our users that include a personal message receive discounts from our hoteliers">
                <p>Our data shows that when our users include a polite personal message they are much more likely to
                  receive discounts from our hoteliers.</p>
              </div>
            </h3>
            <textarea style="text-align: left; font-size:18px; padding: 10px;" [(ngModel)]="personalRequestText"
              id="personalRequest" maxlength="{{ personalRequestMaxLength }}" placeholder="Example: 'My family and I are planning to visit Crete from Germany and we are mostly looking to relax by the sea and enjoy the local gastronomy. We would like to visit the Samaria Gorge and as many beaches as we can during our stay.
                      
                      Thank you!'"></textarea>
          </div>
        </div>
        <div class="cta-wrap">
          <button class="cta-button" [disabled]="requestButtonDisabled"
            (click)="getResults('withRequest'); angulartics2Track('SubmitYourRequestClicked')">I am ready!</button>
        </div>
      </section>
</div>

<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
  >
  <p style="font-size: 20px; color: white;">Loading...</p>
</ngx-spinner>